import React from 'react';
import './style.css';

function RangeSlider({ id, label, value, onChange, min = 0, max = 100, step = 1, hint, suffix, className = '' }) {
  const numValue = Number(value) || min;
  const percentage = ((numValue - min) / (max - min)) * 100;

  function handleChange(e) {
    if (onChange) {
      onChange(e);
    }
  }

  return (
    <div className={`field ${className}`}>
      {label && (
        <label className="field-label" htmlFor={id}>
          {label}
        </label>
      )}
      <div className="range-slider-container">
        <input
          id={id}
          type="range"
          className="range-slider-input"
          min={min}
          max={max}
          step={step}
          value={numValue}
          onChange={handleChange}
          style={{ '--range-progress': `${percentage}%` }}
        />
        <div className="range-slider-info">
          <span className="range-slider-value">
            {numValue}{suffix ? ` ${suffix}` : ''}
          </span>
          <span className="range-slider-limits">{min} — {max}</span>
        </div>
      </div>
      {hint && <p className="range-slider-hint">{hint}</p>}
    </div>
  );
}

export default RangeSlider;
